import { Link } from "react-router-dom";
import { articles, type Article } from "@/mocks/articles";
import { categoryMap } from "@/mocks/categories";
import { formatHeat } from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";

const medal = ["bg-accent-500", "bg-secondary-500", "bg-background-400"];

export default function TopRank() {
  const top = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="实时人气榜"
        title="今日人气 TOP 5"
        description="按当前热度实时排序，反映读者此刻最关注的作品，口碑与热度兼具，闭眼追不踩雷。"
        action={
          <Link
            to="/category/blood"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-5">
        {top.map((a: Article, i: number) => {
          const cat = categoryMap[a.category];
          return (
            <Link
              key={a.id}
              to={`/article/${a.slug}`}
              className="group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
                <img
                  src={a.cover}
                  alt={`${a.title}漫画`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-2 top-2 flex h-9 w-9 items-center justify-center rounded-md text-lg font-black text-background-50 ${medal[i] ?? "bg-primary-500"}`}
                >
                  {i + 1}
                </span>
                <span className="absolute bottom-2 left-2 rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-background-50">
                  {cat?.name ?? "漫画"}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="line-clamp-1 text-sm font-bold text-foreground-950">{a.title}</h3>
                <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
                  <span className="font-semibold text-primary-600">{a.rating.toFixed(1)} 分</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-500"></i>
                    {formatHeat(a.heat)}
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}